<template>
    <div class="receipt">
        <div v-show="show_content">
            <div
                v-if="template == '1x3' && paper_size == 'A4'"
                ref="printable" class="A4 template_1x3" :class="[handle_a4_1x3_class(index), {'print-by-A4': paper_size == 'A4'}]">
                <A4-1x3
                    :logo_url="logo_url"
                    :title="title"
                    :sub_title="sub_title"
                    :force_location="force_location"
                    :customer_service_hotline="customer_service_hotline"
                    :core_waybill="core_waybill"
                    :logistician="logistician"
                    :key="core_waybill.identity"
                    :distribution="distribution"
                    :blank_value_text="blank_value_text">
                </A4-1x3>
            </div>
            <div
                v-else
                ref="printable" class="A5" :class="{ 'print-by-A4': paper_size == 'A4' }">
                <A4-1x2
                    :logo_url="logo_url"
                    :title="title"
                    :sub_title="sub_title"
                    :force_location="force_location"
                    :customer_service_hotline="customer_service_hotline"
                    :core_waybill="core_waybill"
                    :logistician="logistician"
                    :key="core_waybill.identity"
                    :distribution="distribution"
                    :blank_value_text="blank_value_text">
                </A4-1x2>
            </div>
        </div>
    </div>
</template>

<script>
import A4_1x2 from './item_template/A4_1x2.vue'
import A4_1x3 from './item_template/A4_1x3.vue'

export default {
    props: {
        core_waybill: {
            type: Object,
            default() {
                return {
                    identity: null,
                    number: null,
                    consignee_name: null,
                    consignee_phone: null,
                    consignee_address: null,
                    original_number: null,
                    sender_name: null,
                    sender_phone: null,
                    sender_address: null,
                    // 件數最少顯示1（表示運單底下沒有子單只有自己）
                    pieces: null,
                    weight_in_kilo: null,
                    collection: null,
                    goods_name: null,
                    shipping_date: null,
                    shipping_period: null,
                    shipping_note: null,
                }
            }
        },
        index: Number,
        logo_url: String,
        title: String,
        sub_title: String,
        customer_service_hotline: String,
        logistician: Object,
        force_location: String,
        show_print_button: {
            type: Boolean,
            default: false,
        },
        show_content: {
            type: Boolean,
            default: false,
        },
        blank_value_text: {
            type: String,
            default: null,
        }
    },
    computed: {
    },
    data() {
        return {
            paper_size: "A5",
            template: "",
            distribution: {
                object: {
                    name: null,
                }
            },
        }
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        handle_a4_1x3_class(index = 0) {
            if (index%3 == 0) {
                return "first"
            }
            if (index%3 == 2) {
                return "last"
            }
        },
        async print() {
            await new Promise(resolve => {
                $(this.$refs.printable).clone().appendTo('div#print')
            })
            await new Promise(resolve => {
                window.print()
            })
        },
        fetch_distribution() {
            if (this.core_waybill.identity) {
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybill_distribute).parse(
                    {core_waybill_identity: this.core_waybill.identity},
                    ""
                )
                return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.distribution = response.data.distribution
                    } else if (response.data.status == "failure") {
                        this.errors = response.data.errors
                        // this.$noty.error("抓取分撥失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.distributions'),
                                reason: ': ' + response.data.errors
                            })
                        )
                    }
                    return response
                })
                .catch(error => {
                    // this.errors.push("抓取分撥失敗" + this.$t('ui.general.network_abnormality')+": "+ error.response.status)
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.distributions'),
                            reason: ': ' +this.$t('ui.general.network_abnormality')+','+ error.response.status
                        })
                    )
                    return Promise.reject(error)
                })
                .then(() => {
                })
            } else {
                return Promise.resolve()
            }

        },
    },
    components: {
        'A4-1x2': A4_1x2,
        'A4-1x3': A4_1x3,
    }
}
</script>

<style scoped lang="scss">
.prices {
    td {
        height: var(--my-receipts-table-half-height) !important;
    }
    .ui.header {
        font-size: 14px;
        margin-bottom: -1px;
        padding-left: 6px;
    }
}
.unit {
    float: right;
    margin-right: 5px;
}
</style>
